// Copyright (c) 2023 Deere & Company

import {
    isNotEmpty,
    isNotNull
} from '../../../claim/shared/services/claim-shared-helper';
import {hasAccess} from '../../../shared/services/security';

const poBoxRegex = /(\bP\.?\s*O\.?\s*Box\b|\bBox\b)/i;

export const containsPOBox = address => poBoxRegex.test(address || '');

export const isValid = (duplicatePinPlate, Validate, security) => [
    isNotNull(duplicatePinPlate.dateSubmmited),
    isNotEmpty(duplicatePinPlate.machineModel),
    isNotEmpty(duplicatePinPlate.pin),
    isNotEmpty(duplicatePinPlate.mailingRecipient),
    isNotEmpty(duplicatePinPlate.missingPlateReason),
    isNotEmpty(duplicatePinPlate.requesterTCSM),
    isNotEmpty(duplicatePinPlate.dealer.location.address1),
    isNotEmpty(duplicatePinPlate.dealer.location.city),
    isNotEmpty(duplicatePinPlate.dealer.location.postalCode),
    isNotEmpty(duplicatePinPlate.dealer.location.state),
    isNotEmpty(duplicatePinPlate.dealer.location.country),
    isNotEmpty(duplicatePinPlate.dealer.phone),
    isNotEmpty(duplicatePinPlate.dealer.account),
    !containsPOBox(duplicatePinPlate.dealer.location.address1),
    !containsPOBox(duplicatePinPlate.dealer.location.address2),
    (Validate.isValidPIN === true || isNotEmpty(duplicatePinPlate.status)),
    !(duplicatePinPlate.status === 'INPROCESS' && hasAccess(security, 'PRT', 'PRT_FACTORY_USER_PIN_PLATE') && !isNotEmpty(duplicatePinPlate.shippingId))
].every(rule => rule);



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/services/validations.js